import { useModuleState } from '@askyourteam-nz/react-library/dist/hooks'; // eslint-disable-line import/no-internal-modules

export default useModuleState;
